import { masterDataService, defaultParams } from 'services'

export const getArticlesApi = async () => {
  return await masterDataService({
    method: 'post',
    url: '/article/query',
    data: {
      where: [
        {
          ...defaultParams,
          articleTypes: {
            code: {
              $notin: ['banner', 'promotion', 'portfolio'],
            },
          },
        },
      ],
      limit: 100,
      relations: ['articleTypes'],
    },
  })
}

export const getArticleByCodeApi = async code => {
  return await masterDataService({
    method: 'post',
    url: '/article/query',
    data: {
      where: [{ ...defaultParams, code }],
      limit: 1,
      relations: ['articleTypes', 'relatedArticles'],
    },
  })
}

export const getArticleTypesApi = async () => {
  return await masterDataService({
    method: 'post',
    url: '/articleType/query',
    data: {
      where: [
        {
          ...defaultParams,
          code: {
            $notin: ['banner', 'promotion', 'portfolio'],
          },
        },
      ],
      limit: 100,
    },
  })
}
